import { combineReducers } from "redux";

import data from "./_data";
import fetching from "./_fetching";
import message from "./_message";

export default combineReducers({ data, fetching, message });



// WEBPACK FOOTER //
// ./src/_reducers/Search/index.js